// Module
var code = "<div class=\"search-input close-input\"> <span class=\"material-icons search-icon\" id=\"text-search-submit\">search</span> <input id=\"search-content\" type=\"text\" placeholder=\"Search...\"/> <span class=\"striimline-icon select-clear close-icon\" style=\"display:none\"></span> </div> ";
// Exports
export default code;